/**
 * 季節判定ユーティリティ
 */

/**
 * 指定した日付が「夏期（3月〜11月）」かどうかを判定する
 * 
 * @param date 判定対象の日付。省略時は現在日時。
 * @returns 3月〜11月の場合は true (UTC 基準で月を判定する)
 */
export function isSummer(date: Date = new Date()): boolean {
  const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11
  return month >= 3 && month <= 11;
}

/**
 * 指定した日付が「冬期（12月〜2月）」かどうかを判定する
 * 
 * @param date 判定対象の日付。省略時は現在日時。
 * @returns 12月〜2月の場合は true (UTC 基準で月を判定する)
 */
export function isWinter(date: Date = new Date()): boolean {
  const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11
  return month === 12 || month === 1 || month === 2;
}
